import moment from 'moment';

export const secondFormat = seconds =>
  moment.utc(moment.duration(Number(seconds), 'seconds').as('milliseconds')).format('m:ss');
